// extracted by mini-css-extract-plugin
export default {"thumbnail":"CarouselThumbnail-module__thumbnail--Ckgry","isDragging":"CarouselThumbnail-module__isDragging--pBEfA"};